// M26.5 Part 5 — shared "real data or —, never a fabricated 0" formatting,
// used by both WorkforceEmployeeCard.vue and AiProfileDrawer.vue so the two
// surfaces never disagree on how a null/undefined metric reads.
export function fmt(value, suffix = '') {
  return value === null || value === undefined ? '—' : `${value}${suffix}`;
}

export function fmtMs(value) {
  if (value === null || value === undefined) return '—';
  return value < 1000
    ? `${Math.round(value)}ms`
    : `${(value / 1000).toFixed(1)}s`;
}

export function relativeTime(iso) {
  if (!iso) return '—';
  const sec = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  if (sec < 60) return 'just now';
  const min = Math.round(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  return `${Math.round(hr / 24)}d ago`;
}
